import { TThunkAction } from '../../types/redux/thunk';
import { createWsReply } from '../../utils/createWsReply';
import { setActiveReplyMessage as setActiveReplyMessageAction } from '../chatWindow/actions';

export const setActiveReplyMessage =
  (messageId: string): TThunkAction<void> =>
  (dispatch, _, { custom: { messagesMap } }) => {
    const messageItem = messagesMap.get(messageId);

    if (!messageItem) {
      return;
    }

    const { created } = messageItem.message.message;
    const reply = createWsReply(messageId, created);

    dispatch(setActiveReplyMessageAction(reply));
  };
